// Module
var code = "<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path clip-rule=\"evenodd\" d=\"M7.7 3.166h8.6a2 2 0 0 1 2 2v16l-6.292-3.273L5.7 21.166v-16a2 2 0 0 1 2-2Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg> ";
// Exports
module.exports = code;